import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import useAsyncModalConfirm from '@/main/components/shared/asyncModalConfirm/asyncModalConfirm';
import KogPaginationShowMore from '@/main/components/shared/kogPaginationShowMore/kogPaginationShowMore';
import { KeyValue } from '@/main/models/common';
import { KeyValueId } from '@/main/models/common/keyValueId';
import { MappingPartDetailViewResponse, MappingPartSuggestionViewResponse } from '@/main/models/response';
import { getTranslateByKey, isEmpty, isNullUndefined } from '@/main/services/utils';

import RowDetailsMappingParts from './rowDetailsMappingParts';
import RowManualMappingParts from './rowManualMappingParts';
import SkeletonRowDetailsMappingParts from './skeletonRowDetailsMappingParts';
import { IInventoryRegisterForm } from '../../../utilsInventoryRegisterScreen';
import { MapPartInventoryRequest } from '@/main/models/request';
import { quoteItemApi } from '@/main/api';
import { useSearchParams } from 'react-router-dom';

interface IGridMappingPartProps {
  isLoading: boolean;
  dataParts: MappingPartSuggestionViewResponse[];
  dataMappingPart: MappingPartDetailViewResponse | null;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
}

function GridMappingPart({
  dataParts,
  isLoading,
  searchText,
  dataMappingPart,
  setSearchText
}: IGridMappingPartProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const guidSupplierInventoryParams = searchParams.get('guidSupplierInventory');
  const {
    getValues,
    setValue,
  } = useFormContext<IInventoryRegisterForm>();

  const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();
  const [optionSelected, setOptionSelected] = useState('');


  async function sendFeedbackSupplierAPI(findOption: MappingPartSuggestionViewResponse | null = null) {
    if (isNullUndefined(findOption)) return;

    const request: MapPartInventoryRequest = {
      supplierDescription: searchText,
      supplier: isNullUndefined(getValues('supplier.value')) ? '' : String(getValues('supplier.value')),
      guidSupplier: isNullUndefined(getValues('supplier.key')) ? '' : String(getValues('supplier.key')),
      partNumber: isNullUndefined(getValues('partNumberOem')) ? '' : getValues('partNumberOem'),
      piesPartid: isNullUndefined(getValues('xnuupPartId.id')) ? '' : String(getValues('xnuupPartId.id')),
      inferences: isNullUndefined(dataMappingPart) ? '' : String(dataMappingPart?.inferences),
      caseId: isNullUndefined(dataMappingPart) ? 0 : Number(dataMappingPart?.caseId),
      piesPartGuid: findOption.piesPartGuid,
      piesPosGuid: findOption.guidPartPosition,
      guidCategory: findOption.guidPartCategory,
      guidSubCategory: findOption.guidPartSubCategory,
      guidSupplierInventory: String(guidSupplierInventoryParams)
    };

    quoteItemApi.saveMappingPartInventory(request);
  }

  async function handleSelectOption(option: string, dataOption: MappingPartSuggestionViewResponse | null = null) {
    const findOption = option === 'manual' ? dataOption : dataParts.find(item => item.order === option);

    if (!findOption) return;
    const partMessageModal = `${findOption.partCategoryName} ${findOption.partSubCategoryName} ${findOption.xnuupPartId} (${findOption.piesPartId}) ${findOption.partPositionName} `;
    const messageModal = getTranslateByKey("information.areaYouSelectPart").replace("{0}", partMessageModal)
    const isConfirmed = await getConfirmation(messageModal);

    if (!isConfirmed) return;
    if (optionSelected === option) return;

    if (option !== 'manual') {
      await sendFeedbackSupplierAPI(findOption);
    }

    const categoryValue: KeyValue | null = findOption ? { key: findOption.guidPartCategory, value: findOption.partCategoryName } : null;
    const subCategoryValue: KeyValue | null = findOption ? { key: findOption.guidPartSubCategory, value: findOption.partSubCategoryName } : null;
    const positionValue: KeyValue | null = findOption ? { key: findOption.guidPartPosition, value: findOption.partPositionName } : null;
    const partValue: KeyValueId | null = findOption ? { key: findOption.piesPartGuid, value: findOption.xnuupPartId, id: findOption.piesPartId } : null;

    setValue('category', categoryValue);
    setValue('subCategory', subCategoryValue);
    setValue('position', positionValue);
    setValue('xnuupPartId', partValue);

    setSearchText('');
    setOptionSelected(option);
  }

  useEffect(() => {
    setOptionSelected('');
  }, [searchText])

  if (isEmpty(searchText)) return null;
  if (isLoading) return <SkeletonRowDetailsMappingParts />
  if (optionSelected !== '') return null;

  return (
    <>
      <KogPaginationShowMore
        dataList={dataParts}
        render={item => (
          <RowDetailsMappingParts
            key={`${item.order}-${item.piesPartGuid}`}
            optionSelected={optionSelected}
            handleSelectOption={handleSelectOption}
            detailsOption={item}
          />
        )}
        renderFinalList={
          <RowManualMappingParts
            idUniqueReducer='RowManualMappingParts'
            optionSelected={optionSelected}
            handleSelectOption={handleSelectOption}
          />
        }
      />
      <ModalConfirmation />
    </>

  )
}

export default GridMappingPart